// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3jsmB","overflowing":"ReadFullNote_overflowing__aisw3"};